import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { FaSave } from "react-icons/fa";
import api from '../../api/manage_database/FlowMeasurementReq';
import createSocket from '../../api/BaseReqWs';
import BackButton from "../../components/BackButton";
import { toast } from 'sonner';
import json_parser from "../../utils/json_parser";
import Spinner from "../../components/Spinner";
import SelectPlace from "../../components/SelectPlace";
import SelectThoroughfare from "../../components/SelectThroughfare";
import SelectTypeLines from "../../components/SelectTypeLines";


const FlowMeasurementNew = () => {

    const [flowMeters, setFlowMeters] = useState([]);
    const [selectedPlace, setSelectedPlace] = useState('');
    const [places, setPlaces] = useState([]);
    const [selectedThoroughfare, setSelectedThoroughfare] = useState('');
    const [thoroughfares, setThoroughfares] = useState([]);
    const [selectedTypeLine, setSelectedTypeLine] = useState('');
    const [typeLines, setTypeLines] = useState([]);

    const [uploadFiles, setUploadFiles] = useState('');

    const [loadingState, setLoadingState] = useState(false);
    
    const navigate = useNavigate();

    useEffect(() => {
        const fetchFlowMeters = async () => {
            try {
                const response = await api.get('flow-meters', {withCredentials: true});
                if (response.data.success) {
                    setFlowMeters(response.data.payload);
                } else {
                    toast.error('Not got data from database');
                }
            } catch (err) {
                console.log(err.response);
            }
        };

        fetchFlowMeters();
    }, []);

    const handleFileChange = (event) => {
        setUploadFiles(Array.from(event.target.files));
    };

    const handleAdd = async (e) => {
        e.preventDefault();
        setLoadingState(true);
        if (flowMeters.length === 0) {
            toast.error('There is no available flow meters!')
            setLoadingState(false);
            return
        }
        const filteredFlowMeterId = flowMeters
            .filter(
                flowmeter => flowmeter.location_id.place === selectedPlace &&
                flowmeter.location_id.thoroughfare === selectedThoroughfare && 
                flowmeter.location_id.type_line === selectedTypeLine)
            .map((flowmeter) => (flowmeter.id))[0]

        if (uploadFiles === ''|| uploadFiles === undefined) {
            toast.error('Choose file to upload!');
            setLoadingState(false);
            return
        }

        if (uploadFiles.length > 30) {
            toast.error('Cannot upload more than 30 files!');
            setLoadingState(false);
            return
        }

        const toastId = toast('');
        const formData = new FormData();
        formData.append("flow_meter_id", filteredFlowMeterId);

        uploadFiles.forEach(file => {
            formData.append("upload_files", file);
        })

        try {
            if (uploadFiles.length > 1) {
                toast.loading(`Uploading ${uploadFiles.length} files...`, {id: toastId});
            } else {
                toast.loading('Uploading 1 file...', {id: toastId});
            }
            
            const response = await api.post(
                '',
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    withCredentials: true
                }
            );
            if (response.data.success) {
                console.log(response.data);
                console.log(response.data.payload.current_state);
                console.log(response.data.payload.all_states);
                console.log(response.data.payload.message);
                toast.loading(
                    `State: ${response.data.payload.current_state}/${response.data.payload.all_states} ${response.data.payload.message}`,
                    {id: toastId, style: { width: '35rem'}}
                );
                const task_id = response.data.payload.task_id;
                
                const socket = createSocket(task_id);

                socket.onopen = () => {
                    console.log('Connection opened!');
                };

                socket.onmessage = (event) => {
                    const data = json_parser(event.data);                    
                    if (data.message !== '') {
                        toast.loading(
                            `State: ${data.current_state}/${data.all_states} ${data.message}`,
                            {
                                id: toastId,
                                style: {
                                    width: '40rem'
                                }
                            }
                        );
                    } else {
                        toast.error(`State: ${data.current_state}/${data.all_states} ${data.error}`,
                            {
                                id: toastId,
                                style: {
                                    width: '40rem'
                                },
                                duration: 10000
                            }
                        );
                        setLoadingState(false);
                    }

                    if (data.message !== '') {
                        if (data.current_state === 5) {
                            toast.success(
                                `State: ${data.current_state}/${data.all_states} ${data.message}`,
                                {
                                    id: toastId,
                                    style: {
                                        width: '35rem'
                                    }
                                }
                            );
                            setLoadingState(false);
                            navigate('/manage-database');
                        }
                    }

                    if (data.error !== '') {
                        if (data.current_state === 4.5) {
                            toast.error(`State: 4/${data.all_states} ${data.error}`,
                                {
                                    id: toastId,
                                    style: {
                                        width: '40rem'
                                    },
                                    duration: 5000
                                }
                            );
                            setLoadingState(false);
                            navigate('/manage-database');
                        }
                    };
                }
                socket.onclose = () => {
                    console.log('Connection closed!');
                    setLoadingState(false);
                    navigate('/manage-database');
                };
                
            } else {
                setLoadingState(false);
                toast.error(response.data.message);
            }
        } catch (err) {
            setLoadingState(false);
            console.log(err.response)
        }
    };

    useEffect(() => {
        const handlePlaces = () => {
            const newplaces = [...new Set(flowMeters.map(item => item.location_id.place))] 
            return newplaces.map((name, index) => ({id: index+1, name: name}));
            
        }
        if (flowMeters.length > 0) {
            setPlaces(handlePlaces());
        }
    }, [flowMeters])

    useEffect(() => {
        const filterPlaces = () => {
            const newthoroughfare = flowMeters.filter(flowmeter => flowmeter.location_id.place === selectedPlace).map((fl, index) => ({id: index+1, name: fl.location_id.thoroughfare}))
            return newthoroughfare.reduce((acc, current) => {
                if (!acc.some(item => item.name === current.name)) {
                    acc.push(current);
                }
                return acc
            }, [])
        }
        if (flowMeters.length > 0) {
            setThoroughfares(filterPlaces())
        }
    }, [selectedPlace])

    useEffect(() => {
        const filterPlacesAndThoroughfares = () => {
            const newTypeLines = flowMeters
                                    .filter(flowmeter => flowmeter.location_id.place === selectedPlace && flowmeter.location_id.thoroughfare === selectedThoroughfare)
                                    .map((fl, index) => ({id: index+1, name: fl.location_id.type_line}))
            
            return newTypeLines.reduce((acc, current) => {
                if (!acc.some(item => item.name === current.name)) {
                    acc.push(current);
                }
                return acc
            }, [])
        }
        if (flowMeters.length > 0) {
            setTypeLines(filterPlacesAndThoroughfares())
        }
    }, [selectedThoroughfare])

    return (
        <div className='flow-measurement-new-container'>
            {loadingState ? <div className="loading-spinner-div">
                <Spinner />
            </div>: null}
            <h2 className='flow-measurement-new-title'>Flow Measurement</h2>
            <form className='flow-measurement-new-card' onSubmit={handleAdd}>
                <div className="choice-input-group">
                    <label
                        htmlFor=''
                        className='bold-label'
                    >
                        Place:
                    </label>
                    <SelectPlace
                        places={places}
                        selectedPlace={selectedPlace}
                        setSelectedPlace={setSelectedPlace}
                    />
                </div>
                <div className="choice-input-group">
                    <label
                        htmlFor=''
                        className='bold-label'
                    >
                        Section:
                    </label>
                    <SelectThoroughfare
                        thoroughfares={thoroughfares}
                        selectedThoroughfare={selectedThoroughfare}
                        setSelectedThoroughfare={setSelectedThoroughfare}
                    />
                </div>
                <div className="choice-input-group">
                    <label
                        htmlFor=''
                        className='bold-label'
                    >
                        Type line:
                    </label>
                    <SelectTypeLines
                        LocationTypeLines={typeLines}
                        selectedlocationTypeLine={selectedTypeLine}
                        setSelectedLocationTypeLine={setSelectedTypeLine}
                    />
                </div>
                <div className="flow-measurement-new-label-select-wrapper">
                    <label
                        htmlFor='fileInput'
                        className='bold-label'
                    >
                        Upload File:
                    </label>
                    <input
                        type='file'
                        id='fileInput'
                        multiple
                        className=''
                        onChange={handleFileChange}
                        accept=".OUT,.DAT,.csv,.LOG"
                    />
                </div>
                <button type='submit' className='flow-measurement-new-button'>Add &nbsp; <FaSave/></button>
            </form>
            <BackButton navigateTo='/manage-database'/>
        </div>
    );
        
};

export default FlowMeasurementNew;